import { exists } from '@/api'

export interface BibliographySearchResultAuthorityItem {
  authorityNo: string
  display: string
  reference: string
  specialty: string
  yearOfBirth: string
  work: string
  bibliographyCount: string
  _fetched: boolean
}

export function BibliographySearchResultAuthorityItemFromJSON(
  json: any
): BibliographySearchResultAuthorityItem {
  return {
    authorityNo: exists(json, 'authority_no') ? String(json.authority_no) : '',
    display: json.display,
    reference: exists(json, 'reference') ? json.reference : '',
    specialty: exists(json, 'specialty') ? json.specialty : '',
    yearOfBirth: exists(json, 'year_of_birth') ? json.year_of_birth : '',
    work: exists(json, 'work') ? json.work : '',
    bibliographyCount: exists(json, 'bibliography_count')
      ? json.bibliography_count
      : '',
    _fetched: false
  }
}
